import { Directive, ElementRef, HostListener } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, Validator } from '@angular/forms';
import { CreditCardValidator } from 'angular-cc-library';
import { Observable } from 'rxjs';

@Directive({
  selector: '[CreditCard][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: CreditCardDirective, multi: true }
  ]
})
export class CreditCardDirective implements Validator {
  validate(control: AbstractControl): { [key: string]: any } {
    if (control) {
      const isInvalid = CreditCardValidator.validateCCNumber(control);
      if (isInvalid) {
        return { creditCard: { value: control.value } };
      }
    }
    return null;
  }
}
